module.exports = __webpack_public_path__ + "img/icon-alipay-plus.92c44434.png";